var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
import cx from 'classnames';
const SvgIconComponent = (props, ref) => ((props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 112,
  height: 16,
  fill: "none",
  viewBox: "0 0 112 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.281 13.377h13.352l-.776.835H.28v-.835zm110.987.835h-16.69l.833-.835h15.857zM.281 11.709h15.02l-.823.835H.281zm0-2.504h16.69l-.83.835H.28v-.835zm110.99 3.339H96.25l.826-.835h14.195zm-12.54-3.339h12.535v.835H97.914zM14.469 15.01l6.982-9.145h8.671c.96 0 .96.339.46.979-.46.602-1.265 1.693-1.764 2.333-.23.339-.69.903.767.903h11.587c-.96 1.28-4.105 4.968-9.707 4.968-4.527-.038-16.996-.038-16.996-.038m40.054-5.805-3.681 5.009h-9.67l3.682-5.009zm15.017 0-3.683 5.009h-9.67l3.682-5.009h9.67zm3.234 0s-.726.987-1.07 1.442c-1.262 1.631-.153 3.567 3.938 3.567h15.983l3.786-5.009z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m19.648.021-3.515 4.336h19.084c.966 0 .966.322.464.931-.464.573-1.275 1.612-1.777 2.221-.232.287-.696.86.772.86h7.804l2.318-2.866c1.43-1.756.116-5.446-4.983-5.446C35.217.021 19.648.021 19.648.021M71.086 8.37H46.18L52.983.02H63.15l-3.87 4.786h4.535L67.725.02H77.89zM91.243.021 84.467 8.37H73.719L80.495.021z"
}))))({
  ...props,
  className: cx('PA-Svg', props.className)
}, ref);
const SvgClientLogo4 = SvgIconComponent;
const ForwardRef = /*#__PURE__*/forwardRef(SvgClientLogo4);
export default ForwardRef;